import * as tslib_1 from "tslib";
import { DataStore } from './common/data-store';
import { NavigationService } from './navigation-service.service';
var NavigationStoreService = /** @class */ (function (_super) {
    tslib_1.__extends(NavigationStoreService, _super);
    function NavigationStoreService(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        return _this;
    }
    NavigationStoreService.prototype.populateStore = function (appName, accessOptions, domain, userRoles$) {
        var _this = this;
        this.navigationService
            .getNav(appName, accessOptions, domain, userRoles$)
            .subscribe(function (newData) {
            if (!!newData) {
                _this.setData(newData);
            }
        });
        return this.getData();
    };
    NavigationStoreService.prototype.findNavLinkByName = function (navId, navData) {
        var e_1, _a;
        var navLink;
        if (navData !== undefined && navData.length > 0) {
            try {
                for (var navData_1 = tslib_1.__values(navData), navData_1_1 = navData_1.next(); !navData_1_1.done; navData_1_1 = navData_1.next()) {
                    var link = navData_1_1.value;
                    var Link = navData.find(function (link) { return link.name === navId; });
                    if (Link !== undefined) {
                        return Link;
                    }
                    if (!!link.children && link.children.length > 0) {
                        navLink = this.findNavLinkByName(navId, link.children);
                    }
                    if (!!navLink) {
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (navData_1_1 && !navData_1_1.done && (_a = navData_1.return)) _a.call(navData_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return navLink;
    };
    NavigationStoreService.prototype.addQueryParam = function (params) {
        var _this = this;
        this.getData().subscribe(function (navLinks) {
            var NavData = navLinks;
            if (NavData.length > 0)
                params.map(function (param) {
                    param.navIds.map(function (id) {
                        if (!!id) {
                            var nLink = _this.findNavLinkByName(id.trim(), NavData);
                            console.log(nLink);
                            if (!!nLink && !!nLink.url) {
                                _this.appendParmaToUrl(nLink, param.paramName, param.paramValue);
                            }
                        }
                    });
                });
        });
    };
    NavigationStoreService.prototype.appendParmaToUrl = function (navLink, paramName, paramValue) {
        if (navLink.url.indexOf(paramName) > 0) {
            navLink.url = navLink.url.split(paramName)[0].concat(paramName + "=" + paramValue);
        }
        else if (navLink.url.indexOf('?') > 0) {
            navLink.url = navLink.url.concat("&" + paramName + "=" + paramValue);
        }
        else {
            navLink.url = navLink.url.concat("?" + paramName + "=" + paramValue);
        }
    };
    return NavigationStoreService;
}(DataStore));
export { NavigationStoreService };
